import { createSlice } from '@reduxjs/toolkit'
import {
  disableBodyScroll,
  enableBodyScroll,
} from 'shared/helpers/toggleBodyScroll'

import { GlobalModalState } from './types'

const initialState: GlobalModalState = {
  body: null,
  withPadding: false,
  maxWidth: null,
  modalProps: null,
}

export const GlobalModalSlice = createSlice({
  name: 'GlobalModalSlice',
  initialState,
  reducers: {
    openModal: (state, { payload }) => {
      state.body = payload.body
      state.withPadding = payload.withPadding
      if (payload.maxWidth) state.maxWidth = payload.maxWidth
      if (payload.modalProps) state.modalProps = payload.modalProps
      disableBodyScroll()
    },
    closeModal: () => {
      setTimeout(() => {
        enableBodyScroll()
      }, 400)
      return initialState
    },
  },
})

export const GlobalModalSliceActions = GlobalModalSlice.actions

export const globalModalSlice = GlobalModalSlice.reducer
